import Axios from "./axios";

const resource = "feature-parallaxes";

export default {
  get() {
		return Axios.get(`${resource}`);
	}
}